<template>
  <div class="variables">
    <strong>Available Variables</strong>
    <p class="hint">Click to insert:</p>

    <div class="list">
      <button
        v-for="variable in variables"
        :key="variable.value"
        @click="$emit('insert', variable.value)"
      >
        {{ variable.label }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    variables: {
      type: Array,
      required: true
    }
  }
};
</script>

<style scoped>
.variables {
  margin-bottom: 12px;
  background-color: #f0f6ff;
    padding: 16px;
    border-radius: 8px;
    color: #0b3aa1;
    font-size: 12px;
    font-weight: 600;
    border: 1px solid #afc6fa;
}

.list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}

.hint {
  margin-top: 10px;
  margin-bottom: 0px;
}

button {
  padding: 4px 8px;
  border: 1px solid #afc6fa;
  color: #2563eb;
  border-radius: 4px; 
  background: #fff;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/EmailTemplate/AvailableVariables.vue